import React from "react";
import { Star, Quote } from "lucide-react";
import Reveal from "../Reveal";

const testimonials = [
  {
    name: "Marina Costa",
    pet: "Tutora do Thor",
    text: "A Tia Sandra e sua equipe são apaixonadas pelos pets! Meu Thor adora ir ao banho — sai cheiroso e feliz toda vez.",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=160&q=80",
  },
  {
    name: "Lucas Almeida",
    pet: "Tutor da Mel",
    text: "Atendimento impecável e ambiente muito limpo. O cuidado foi atencioso e cheio de carinho. Recomendo demais!",
    avatar: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=160&q=80",
  },
  {
    name: "Camila Ribeiro",
    pet: "Tutora da Luna",
    text: "Profissionais que tratam meu pet com tanto carinho quanto eu. A tosa ficou linda e a Luna não chega estressada.",
    avatar: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=160&q=80",
  },
];

export default function Testimonials() {
  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="relative overflow-hidden py-24 sm:py-32 text-white bg-transparent"
    >
      <div className="container-pad relative z-10">
        <div className="max-w-3xl mb-14">
          <Reveal as="div" className="inline-block px-4 py-1.5 rounded-full bg-white/12 backdrop-blur-xl border border-white/15 text-white text-xs font-bold uppercase tracking-[0.18em] mb-5">
            Depoimentos
          </Reveal>

          <Reveal as="h2" delay={80} className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-[1.1]">
            O que dizem <span className="italic text-gold">nossas famílias</span>.
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <Reveal
              key={t.name}
              delay={i * 100}
              as="div"
              data-testid={`testimonial-${i}`}
              className="group relative rounded-[30px] p-7 sm:p-8 bg-white/10 backdrop-blur-xl border border-white/15 shadow-[0_25px_80px_rgba(0,0,0,0.22)] hover:bg-white/16 hover:-translate-y-1 hover:shadow-[0_35px_100px_rgba(0,0,0,0.30)] transition-all overflow-hidden"
            >
              <div className="absolute -top-20 -right-20 w-44 h-44 bg-gold/15 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity" />

              <Quote className="relative w-10 h-10 text-gold/60 mb-3" />

              <div className="relative flex items-center gap-1 text-gold mb-4">
                {[...Array(5)].map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-gold" />
                ))}
              </div>

              <p className="relative text-white/78 leading-relaxed text-[15px]">"{t.text}"</p>

              <div className="relative mt-6 flex items-center gap-3 pt-5 border-t border-white/12">
                <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full object-cover ring-2 ring-white/25" />
                <div>
                  <div className="font-heading font-semibold text-white">{t.name}</div>
                  <div className="text-xs text-white/55">{t.pet}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
